import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { getStringHidden } from '../../../views/ganttContainer/gantt/gantt.helper';
import { rolesAuthorizedSir, getCurrentUserRole } from './utils/utils';
import hasPending from '../../../assets/img/gantt/activity-sir-pending.svg';
import { textEditor } from '../../../assets/js/field_config/editor-inline-gantt';
import { columnCache } from '../../../services/columnCache';
import TooltipHTML from '../../TooltipHTML';

const textCol = (gantt, t) => {
  const name = 'text';
  const isVisible = isColumnVisibleByDefault(name);
  const role = getCurrentUserRole();
  const canEdit = rolesAuthorizedSir.includes(role);
  const tooltipText = canEdit
    ? t('activity_pending_sir_tooltip')
    : t('activity_pending_sir_tooltip_no_permission');

  return {
    name,
    label: t('gantt.columns.activities', 'Actividades'),
    width: '270',
    resize: true,
    tree: true,
    editor: textEditor,
    hide: !isVisible,
    data_type: 'string',
    groupable: false,
    orderable: false,
    orderable_switch: ['A → Z', 'Z → A'],
    filterable: true,
    template: (activity) => {
      const hasModifications =
        activity.activityModifications &&
        activity.activityModifications.length > 0;
      if (!hasModifications) {
        const cachedResult = columnCache.get('text', activity.id);
        if (cachedResult !== undefined) {
          return cachedResult;
        }
      }

      const hasChild = gantt.hasChild(activity.id);
      let isOdd = gantt.oddColsConfig?.text || false;
      let iconToModifications;

      if (activity.pendingRequests && activity.pendingRequests.length > 0) {
        iconToModifications = hasPending;
      }

      const level = activity.$level;
      const RIGHT_ALIGN = 5 * level;
      const htmlH = getStringHidden(activity.text, 'text', -27);
      let textToRender = `<span class="string-v">${activity.text}</span>`;
      const isSel = gantt.isSelectedTask(activity.id);

      if (
        (['task', 'milestone'].includes(activity.type) ||
          (!activity.type && activity.proplannerId)) &&
        isSel
      ) {
        textToRender = `<span class="string-v">
                                      ${activity.text}
                                  </span>
                              </span>
                              `;
      }

      const modificationIconHtml = iconToModifications
        ? TooltipHTML({
            text: tooltipText,
            container: `
              <span style="position: relative; float: right; cursor: pointer; margin-left: -${RIGHT_ALIGN}px">
                  <img class="request-empty-gantt" width="15" src="${iconToModifications}"  onclick="event.preventDefault(); event.stopPropagation(); ${canEdit ? `window.to_use_react_gantt.openScheduleImpactRequestModal(${activity?.id})` : ''}" />
              </span>`,
            task_id: activity.id,
            name: 'pending-icon',
            gantt,
            gantt_string: 'window.to_use_react_gantt'
          })
        : '';

      const result = `
          <div class="${isOdd ? 'odd-col' : 'non-odd-col'} request-btn-task-gantt" style="width: 88%;">
              <span style="${hasChild ? 'font-weight: 600' : 'font-weight: 100'}; 
              color: #121212;">
                  <span class="cut-text-and-dot ${iconToModifications ? 'fix-name-at-new-gantt' : ''}">
                      ${textToRender}
                      ${htmlH}
                  </span>
                  ${modificationIconHtml}
              </span>
          </div>
          `;

      if (!hasModifications) {
        columnCache.set('text', activity.id, result);
      }

      return result;
    }
  };
};

export default textCol;
